export class EnumTools {
  /**
   * Converts a string to a value from the provided enum.
   * Returns `undefined` if no match is found.
   */
  public static fromString<T extends Record<string, string>>(
    enumObj: T,
    value: string | undefined,
  ): T[keyof T] | undefined {
    const enumValues = Object.values(enumObj) as string[];
    return value !== undefined && enumValues.includes(value) ? (value as T[keyof T]) : undefined;
  }
}
